import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const DELEGATION_REPORT_CONFIG: ReportConfig = {
  id: 'delegation',
  title: 'Delegation Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.DELEGATION.VIEW,
    export: PERMISSIONS.GSE.REPORTS.DELEGATION.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search',
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range',
    },
    {
      type: 'dropdown',
      field: 'delegator',
      label: 'Delegator',
      placeholder: 'Delegator',
    },
    {
      type: 'dropdown',
      field: 'delegate',
      label: 'Delegate',
      placeholder: 'Delegate',
    },
    {
      type: 'dropdown',
      field: 'delegationStatus',
      label: 'Status',
      placeholder: 'Status',
    },
  ],

  columns: [
    {
      field: 'startDate',
      header: 'Start Date',
      type: 'text',
      pipes: ['date'],
      width: '12%',
    },
    {
      field: 'endDate',
      header: 'End Date',
      type: 'text',
      pipes: ['date'],
      width: '12%',
    },
    {
      field: 'delegator',
      header: 'Delegator',
      type: 'text',
      width: '18%',
    },
    {
      field: 'status',
      header: 'Status',
      type: 'text',
      pipes: ['titlecase'],
      width: '14%',
    },
    {
      field: 'delegate',
      header: 'Delegate',
      type: 'text',
      width: '18%',
    },
    {
      field: 'taskCount',
      header: 'Task Count',
      type: 'number',
      width: '26%',
    },
  ],
};
